import { Button } from '@/components/ui/button';

type Props = {
  dirty: boolean;
  onReset: () => void;
  onCancel: () => void;
  onSave: () => void;
};

export default function UserSidebarFooter({
  dirty,
  onReset,
  onCancel,
  onSave
}: Props) {
  return (
    <div className="flex flex-wrap items-center justify-end gap-2 p-4 border-t border-border bg-card">
      <Button variant="ghost" size="sm" onClick={onReset}>
        Reset
      </Button>
      <Button variant="ghost" size="sm" onClick={onCancel}>
        Cancel
      </Button>
      <Button size="sm" onClick={onSave} disabled={!dirty} id="user-sidebar-save">
        Save changes
      </Button>
    </div>
  );
}
